var map = {
	"./Animals.png": 379,
	"./Art.png": 708,
	"./Celebrities.png": 403,
	"./Entertainment: Board Games.png": 733,
	"./Entertainment: Books.png": 66,
	"./Entertainment: Cartoon & Animations.png": 197,
	"./Entertainment: Comics.png": 23,
	"./Entertainment: Film.png": 641,
	"./Entertainment: Japanese Anime & Manga.png": 43,
	"./Entertainment: Music.png": 247,
	"./Entertainment: Musicals & Theatres.png": 369,
	"./Entertainment: Television.png": 10,
	"./Entertainment: Video Games.png": 751,
	"./General Knowledge.png": 634,
	"./Geography.png": 586,
	"./History.png": 790,
	"./Mythology.png": 798,
	"./Politics.png": 70,
	"./Science & Nature.png": 710,
	"./Science: Computers.png": 73,
	"./Science: Gadgets.png": 312,
	"./Science: Mathematics.png": 823,
	"./Sports.png": 361,
	"./Vehicles.png": 669,
	"./any-category.png": 314,
	"./settings.png": 219,
	"./star-empty.png": 238,
	"./star.png": 687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;